const ThankYou = ({ goBack }: { goBack: () => void }) => {
  return (
    <div className="bg-storytan flex flex-col justify-center items-center gap-8 h-[25.5rem]">
      <h2 className="text-center text-2xl md:text-4xl mb-4 font-bold text-storyblue">
        Thank you for your Order!
      </h2>
      <button
        className={
          'bg-storyblueSecondLightText text-white hover:text-white font-bold rounded-2xl px-4 py-2 text-sm'
        }
        onClick={() => {
          goBack();
        }}
      >
        Close
      </button>
    </div>
  );
};

export default ThankYou;